import { AdminPanelSettings } from "@mui/icons-material"
import { lastUpdatedPolicyDate, companyName, companyEmail, companyPhone } from "../../app/store/constant"
import { H3, H2, H5, Body2 } from "../../themes/typography"
import "../../styles/saas-pages/TermsAndConditions.css"

export default function PrivacyPolicy() {

    return (
        <div className="page-view">
            <div className="page-wrapper">

                <div className="terms-container">
                    <div className="terms-wrapper">

                        <div className="terms-icon-container">
                            <AdminPanelSettings color="tertiary" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="content-container">

                            <header className="terms-header">
                                <H2 fontWeight={700}>
                                    Privacy Policy
                                </H2>

                                <Body2 color="var(--secondary-color)">
                                    {`Last updated: ${lastUpdatedPolicyDate}`}
                                </Body2>

                                <H3 color="var(--tertiary-color)" fontWeight={600}>
                                    {companyName}
                                </H3>
                            </header>

                            <main className="terms-content">

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        1. About Shmooz
                                    </H5>
                                    <Body2>
                                        Shmooz is a social networking and discovery platform for events and outings. We connect people, event organizers, and venues, making it easy to explore, connect, and attend activities that match your interests.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        2. Information We Collect
                                    </H5>
                                    <Body2>
                                        We may collect the following information when you use our Platform:
                                    </Body2>

                                    <ul className="terms-list">
                                        <Body2>
                                            <li>
                                                <strong>Personal Information (provided by you)</strong>: Name, email, phone number, date of birth, payment details (processed securely; we do not store card details), documents voluntarily uploaded (e.g., ownership proof for venues).
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                <strong>Information Automatically Collected</strong>: Device and log data (IP address, browser type, operating system, device identifiers), location data (when you allow location access), usage data (pages visited, events viewed/booked, interactions), cookies and analytics (see Section 7).
                                            </li>
                                        </Body2>
                                    </ul>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        3. How We Use Your Information
                                    </H5>
                                    <Body2>
                                        Your information is used to:
                                    </Body2>

                                    <ul className="terms-list">
                                        <Body2 >
                                            <li>
                                                Provide and manage your account and services.
                                            </li>
                                        </Body2>
                                        <Body2 >
                                            <li>
                                                Process ticket purchases, bookings, and payments.
                                            </li>
                                        </Body2>
                                        <Body2 >
                                            <li>
                                                Send confirmations, service updates, and event reminders.
                                            </li>
                                        </Body2>
                                        <Body2 >
                                            <li>
                                                Improve our Platform through analytics and feedback.
                                            </li>
                                        </Body2>
                                        <Body2 >
                                            <li>
                                                Personalize recommendations and content.
                                            </li>
                                        </Body2>
                                        <Body2 >
                                            <li>
                                                Communicate with you about offers, promotions, and support.
                                            </li>
                                        </Body2>
                                        <Body2 >
                                            <li>
                                                Comply with legal and regulatory obligations.
                                            </li>
                                        </Body2>
                                    </ul>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        4. Sharing of Information
                                    </H5>
                                    <Body2>
                                        We do not sell your personal data. However, we may share your information with:
                                    </Body2>

                                    <ul className="terms-list">
                                        <Body2>
                                            <li>
                                                Event organizers and venue partners (for fulfilling bookings).
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Third-party service providers (e.g., payment gateways, analytics providers).
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Law enforcement or regulators (where legally required).
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Business transfers (in case of mergers, acquisitions, or restructuring).
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                With your explicit consent, where applicable.
                                            </li>
                                        </Body2>
                                    </ul>

                                    <Body2>
                                        We may also share anonymized or aggregated data that cannot identify you.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        5. Cookies & Tracking
                                    </H5>
                                    <Body2>
                                        Our Platform uses cookies and similar technologies to:
                                    </Body2>

                                    <ul className="terms-list">
                                        <Body2>
                                            <li>
                                                Improve your browsing experience.
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Remember your preferences.
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Analyze performance and usage.
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Deliver relevant ads and promotions.
                                            </li>
                                        </Body2>
                                    </ul>

                                    <Body2>
                                        You can manage cookies through your browser settings. Disabling cookies may limit some Platform features.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        6. Your Rights & Choices
                                    </H5>
                                    <Body2>
                                        You may:
                                    </Body2>

                                    <ul className="terms-list">
                                        <Body2>
                                            <li>
                                                Access, update, or correct your information in your account settings.
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                Request account deletion through the Platform (permanently removes your data, except where retention is legally required).
                                            </li>
                                        </Body2>
                                    </ul>

                                    <Body2>
                                        For any requests, contact us at the details in Section 12.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        7. Data Storage & Security
                                    </H5>
                                    <Body2>
                                        Data is stored securely on cloud servers with appropriate encryption and safeguards. We take reasonable measures to protect your data from unauthorized access, alteration, or disclosure. However, no system is 100% secure. Use of the Platform is at your own risk.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        8. Retention of Data
                                    </H5>
                                    <Body2>
                                        We retain your information for as long as necessary to provide services or comply with legal obligations. If you delete your account, residual copies may remain in backups for a limited time.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        9. Third-Party Links
                                    </H5>
                                    <Body2>
                                        Our Platform may link to external websites or services. We are not responsible for their privacy practices. Please review their policies before sharing personal information.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        10. Changes to This Policy
                                    </H5>
                                    <Body2>
                                        We may update this Privacy Policy periodically. The updated version will be posted on this page with a revised “Last Updated” date. We encourage you to review it regularly.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        11. Governing Law & Dispute Resolution
                                    </H5>
                                    <Body2>
                                        This Policy is governed by the laws of India. Disputes shall be resolved in accordance with the Arbitration and Conciliation Act, 1996, with arbitration in Surat, India.
                                    </Body2>
                                </section>

                                <section className="terms-section">
                                    <H5 color="var(--secondary-color)" fontWeight={700}>
                                        12. Contact us for Grievance's
                                    </H5>
                                    <Body2>
                                        If you have questions, concerns, or wish to exercise your privacy rights, contact:
                                    </Body2>
                                    <div className="contact-info">
                                        <Body2 color="var(--tertiary-color)">
                                            <strong>
                                                {companyName}
                                            </strong>
                                        </Body2>
                                        <Body2>
                                            Email : <a href={`mailto:${companyEmail}`} style={{ textDecoration: 'underline', color: 'var(--tertiary-color)' }}>
                                                {companyEmail}
                                            </a>
                                        </Body2>
                                        <Body2>
                                            Phone : <a href={`tel:${companyPhone}`} style={{ textDecoration: 'underline', color: 'var(--tertiary-color)' }}>{companyPhone}</a>
                                        </Body2>
                                    </div>
                                </section>

                            </main>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}